import { CustomInputEditorNg2MoneyComponent } from "src/app/views/shared/custom-input-editor-ng2-money/custom-input-editor-ng2-money.component";
import {
  obterConfiguracaoAdd,
  obterConfiguracaoBase,
  obterConfiguracaoDeletar,
  ObterConfiguracaoEditar,
} from "./configuracao-tabela-base";
import { CustomInputEditorNg2PercentageComponent } from "src/app/views/shared/custom-input-editor-ng2-percentage/custom-input-editor-ng2-percentage.component";
import { formatarValorParaReal } from "src/app/utils/formata-valor";

export function obterConfiguracaoHonorarios() {
  const base = obterConfiguracaoBase();

  return {
    ...base,
    add: obterConfiguracaoAdd(true),
    edit: ObterConfiguracaoEditar(true),
    delete: obterConfiguracaoDeletar(),
    columns: {
      inicial: {
        editor: {
          type: "custom",
          component: CustomInputEditorNg2MoneyComponent,
        },
        valuePrepareFunction: (value) => {
          var newValue = formatarValorParaReal(value);
          return newValue;
        },
        title: "Valor Inicial",
        width: "23%",
        filter: false,
      },
      final: {
        editor: {
          type: "custom",
          component: CustomInputEditorNg2MoneyComponent,
        },
        valuePrepareFunction: (value) => {
          var newValue = formatarValorParaReal(value);
          return newValue;
        },
        title: "Valor Final",
        width: "23%",
        filter: false,
      },
      percentual: {
        editor: {
          type: "custom",
          component: CustomInputEditorNg2PercentageComponent,
        },
        valuePrepareFunction: (value) => {
          var newValue = value + "%";
          return newValue;
        },
        title: "Porcentagem",
        width: "20%",
        filter: false,
      },
      valor: {
        editor: {
          type: "custom",
          component: CustomInputEditorNg2MoneyComponent,
        },
        valuePrepareFunction: (value) => {
          var newValue = "R$ " + value;
          return newValue;
        },
        title: "Valor",
        width: "20%",
        filter: false,
      },
    },
  };
}
